var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-slider',{staticClass:"range-slider-comp",attrs:{"min":_vm.min,"max":_vm.max,"interval":_vm.interval,"disabled":_vm.disabled,"tooltip":_vm.enableTooltip},model:{value:(_vm.updateValue),callback:function ($$v) {_vm.updateValue=$$v},expression:"updateValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }